__turbopack_context__.v({
  "profile-summary-actions": "profile-summary-actions-module-scss-module__gml-BG__profile-summary-actions",
});
